"use client";
import React from "react";
import Image from "next/image";
import { ArrowRight } from "lucide-react";

interface Picture {
    data: {
        id: string;
        attributes: {
            url: string;
            name: string;
            alternativeText: string;
        };
    };
}

interface Card {
    title: string;
    text: string;
    href: string;
    hrefText: string;
    image: Picture;
}

interface DataDisplayProps {
    data: {
        id: number;
        title: string;
        subtitle: string;
        Card: Card[];
        isLive: boolean;
        useH1Tag?: boolean;
    };
}

export default function DataDisplay_Knowledge_Layout1({ data }: DataDisplayProps) {
    return (
        <>
            <h1>hello</h1>
        </>
    );
}